import { TaskStatus } from '../enums/TaskStatus';
import { createRuntimeConfig } from './runtimeConfig';
import type { RuntimeEnvironment } from './runtimeConfig';

const runtimeEnvironment: RuntimeEnvironment = window.__WETRANSLATE_RUNTIME_CONFIG__ || {};

const environment: RuntimeEnvironment = {
    API_PROTOCOL: runtimeEnvironment.API_PROTOCOL || process.env.REACT_APP_API_PROTOCOL,
    API_HOSTNAME: runtimeEnvironment.API_HOSTNAME || process.env.REACT_APP_API_HOSTNAME,
    API_PORT: runtimeEnvironment.API_PORT || process.env.REACT_APP_API_PORT,
    WEBSITE_NAME: runtimeEnvironment.WEBSITE_NAME || process.env.REACT_APP_WEBSITE_NAME,
};

const runtimeConfig = createRuntimeConfig(environment);

interface ConfigInterface {
  env: 'production' | 'development';
  api: {
    socketProtocol: 'ws' | 'wss';
    protocol: 'http' | 'https';
    baseUrl: string;
    port: number;
  };
  websiteName: string;
  statisticsStartDate: string;
  timeout: number;
  loginUrl: string;
  refreshTokenExpiry: number;
  paginationOptionsCount: number;
  uploadLimit: number;
  recaptchaSiteKey: string;
  regex: {
    lowerCase: RegExp;
    upperCase: RegExp;
    special: RegExp;
    number: RegExp;
  };
  allowedEndpoints: string[];
  errorStatuses: TaskStatus[];
  taskStatusesBySection: {
    newTask: TaskStatus[];
    actionNeeded: TaskStatus[];
    inProgress: TaskStatus[];
    finished: TaskStatus[];
  };
}

const config: ConfigInterface = {
    env: process.env.NODE_ENV === 'production' ? 'production' : 'development',
    timeout: 20000,
    loginUrl: '/login',
    refreshTokenExpiry: 86400,
    paginationOptionsCount: 5,
    uploadLimit: 50971520,
    api: {
        ...runtimeConfig.api,
    },
    websiteName: runtimeConfig.websiteName,
    statisticsStartDate: '2012-01-01',
    recaptchaSiteKey: '6Ldo09IbAAAAAGXM-qBG-9av3A17bmSesGkvJbWb',
    regex: {
        lowerCase: /[a-z]/,
        upperCase: /[A-Z]/,
        // eslint-disable-next-line no-useless-escape
        special: /[@$!%*?&\+\-._:/\\=]/,
        number: /\d+/,
    },
    allowedEndpoints: ['/users/forgotpassword', '/users/newpassword', '/oauth/token'],
    errorStatuses: [
        TaskStatus.INCORRECT_TRANSLATION,
        TaskStatus.INVALID_LANGUAGE,
        TaskStatus.INVALID_SOURCE_FILE,
        TaskStatus.PRICE_DECLINED,
    ],
    taskStatusesBySection: {
        newTask: [TaskStatus.NEW_TASK],
        actionNeeded: [
            TaskStatus.INVALID_SOURCE_FILE,
            TaskStatus.TRANSLATION_READY,
            TaskStatus.INCORRECT_TRANSLATION,
            TaskStatus.INVALID_LANGUAGE,
            TaskStatus.UNDER_TRANSLATION,
        ],
        inProgress: [
            TaskStatus.UNDER_TRANSLATION,
            TaskStatus.INVALID_SOURCE_FILE,
            TaskStatus.INVALID_LANGUAGE,
            TaskStatus.TRANSLATION_READY,
        ],
        finished: [TaskStatus.TRANSLATION_READY, TaskStatus.APPROVED],
    },
};

export default config;
